document.addEventListener('DOMContentLoaded', function () {
  var carousel = document.querySelector('#featured-collection');
  var originalItems = carousel.innerHTML;

  carousel.innerHTML += originalItems;

  var flkty = new Flickity(carousel, {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    freeScroll: true
  });

  var previousButton = document.querySelector('[is="previous-button"]');
  var nextButton = document.querySelector('[is="next-button"]');

  previousButton.addEventListener('click', function() {
    flkty.previous();
  });

  nextButton.addEventListener('click', function() {
    flkty.next();
  });

  flkty.on('scroll', function() {
    var sliderCells = flkty.getCellElements();
    var flktyIndex = flkty.selectedIndex;
    var totalSlides = sliderCells.length;

    if (flktyIndex >= totalSlides / 2) {
      flkty.select(flktyIndex % (totalSlides / 2), false, true);
    }
  });
});